import { render, staticRenderFns } from "./LmSpinnerBorder.vue?vue&type=template&id=a20e0e1c&scoped=true"
var script = {}
import style0 from "./LmSpinnerBorder.vue?vue&type=style&index=0&id=a20e0e1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20e0e1c",
  null
  
)

export default component.exports